/**
 * @file 知识库添加搜索表单组件
 */
import React from 'react';
import {
  UseFormSearch,
  type ISearchRef,
} from '@gp/pages/Pipeline/ProjectDetails/components/GameOverviewEdit/Components/UseFormSearch';
import { useKnowledgeBaseAddFormConfig } from '../hooks/useKnowledgeBaseAddFormConfig';

export interface IKbAddFormSearchProps {
  config: ReturnType<typeof useKnowledgeBaseAddFormConfig>['config'];
  initialValues: Record<string, unknown>;
  searchFormRef: React.MutableRefObject<ISearchRef | null>;
  resetFields?: string;
  onSubmit: (formValues: unknown) => void | Promise<void>;
}

const KbAddFormSearch: React.FC<IKbAddFormSearchProps> = ({
  config,
  initialValues,
  searchFormRef,
  resetFields,
  onSubmit,
}) =>
  UseFormSearch({
    config,
    // eslint-disable-next-line @typescript-eslint/no-misused-promises
    getFormValue: onSubmit,
    labelSpan: 3,
    column: 1,
    isUnpack: false,
    initialValues,
    resetFields,
    ref: searchFormRef,
    isShowSearchBtn: false,
    className: 'dba-kb-modal__form dbl-search-container',
  }) as React.ReactElement;

export default KbAddFormSearch;
